/**
 * Inspired from
 * https://gist.github.com/jlmakes/47eba84c54bc306186ac1ab2ffd336d4
 */

const polyfill = (() => {
    let clock = +new Date();

    return (callback) => {

        const currentTime = +new Date();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(() => {
                polyfill(callback);
            }, 0);
        }
    };
})();

const requestAnimationFrame = window.requestAnimationFrame       ||
                              window.webkitRequestAnimationFrame ||
                              window.mozRequestAnimationFrame    ||
                              polyfill;

export default requestAnimationFrame;



// WEBPACK FOOTER //
// ./src/main/js/utils/raf-polyfill.js